<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.${company.status}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5">
        <span v-html="$t(`${namespace}.${company.status}.text`)" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="handleSubmit"
        >
          {{ $t(`${namespace}.${company.status}.buttonLabel`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isObject } from 'utils/functions'

export default {
  name: 'ChangeCompanyStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage.changeCompanyStatusDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleSubmit () {
      this.isLoading = true

      try {
        const isValid = await this.$validator.validateAll()

        if (
          !this.isValidObject(this.company) ||
          (this.isValidObject(this.company) && !this.company.id) ||
          (this.isValidObject(this.company) && !this.company.status)
        ) {
          throw new Error()
        }

        if (isValid) {
          await this.$apiService.editCompanyStatus(this.company.id, this.company.status)

          if (this.company.status === 'disable') {
            await this.$apiService.companyDataPurge.create(this.company.id)
          }

          this.$emit('close', true)
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.${this.company.status}.success`)
          })
        }
      } catch (err) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.${this.company.status}.error`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
